export default "__VITE_ASSET__CahT1kds__"